import React, { MouseEventHandler } from 'react';
import { JourneyMenu, JourneyMenuPropsInterface } from 'src/common/JourneyMenu';
import { BellStrongIcon, ChevronRightRegularIcon, NotificationsStrongIcon } from 'src/monet/icons';
import { useReactConstructor } from 'src/utils/react/constructor.hook';
import { DashboardInboxMenuOptionsActionPanelTypes } from './options';

export interface DashboardInboxMenuProps extends Pick<JourneyMenuPropsInterface, 'openRef' | 'closeRef' | 'placement'> {
  renderMenuOrigin: (onClick: MouseEventHandler<HTMLElement>) => any;
  onOpen: () => void;
  onClose: () => void;
  onItemClick: (value: DashboardInboxMenuOptionsActionPanelTypes) => void;
  isLinkLevelSubscriptionEnabled: boolean;
}

export const DashboardInboxMenu = ({
  openRef,
  closeRef,
  onItemClick,
  renderMenuOrigin,
  isLinkLevelSubscriptionEnabled,
  onOpen,
  onClose,
}: DashboardInboxMenuProps) => {
  const onMenuClicked: MouseEventHandler = () => {
    openRef.current();
  };

  useReactConstructor(() => {
    return () => {
      onClose();
    };
  });

  const onNotificationsItemClicked = () => {
    onItemClick('notification');
  };

  return (
    <JourneyMenu
      placement='bottom-start'
      openRef={openRef}
      closeRef={closeRef}
      onOpen={onOpen}
      onClose={onClose}
      renderOrigin={() => renderMenuOrigin(onMenuClicked)}
    >
      <JourneyMenu.Item
        className='text-bedrock-p text-bedrock-black text-left flex gap-2 justify-between'
        onClick={onNotificationsItemClicked}
      >
        <div className='flex items-center gap-2'>
          {isLinkLevelSubscriptionEnabled ? <NotificationsStrongIcon /> : <BellStrongIcon />}
          <span>Notifications</span>
        </div>
        <ChevronRightRegularIcon />
      </JourneyMenu.Item>
    </JourneyMenu>
  );
};
